import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class BetalningsinformationMediatorService {

    get save$() {
        return this.saveSrc.asObservable();
    }

    private readonly saveSrc = new Subject<void>();

    save() {
        this.saveSrc.next();
    }
}
